import Reveal from "./Reveal";

const PARTNERS = [
  { name: "Renukiran", subtitle: "Foundation" },
  { name: "Martini", subtitle: "Café" },
  { name: "Belta", subtitle: "Design" },
  { name: "Cosy", subtitle: "Café" },
  { name: "Adwait", subtitle: "Mahakumbh" },
  { name: "Gyan Devi", subtitle: "School" },
  { name: "ALLEN", subtitle: "Institute" },
  { name: "Renukiran", subtitle: "Foundation" },
];

export default function PartnerMarquee() {
  return (
    <section className="relative py-20 md:py-28 bg-[var(--bg)] border-y border-[var(--line)] overflow-hidden">
      <div className="px-5 md:px-10 mb-10">
        <Reveal>
          <div className="flex items-baseline justify-between flex-wrap gap-4">
            <div>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — Walls we've touched
              </div>
              <h2 className="mt-3 font-display text-3xl md:text-5xl text-[var(--bone)]">
                Trusted by places{" "}
                <span className="italic font-extralight">that matter</span>.
              </h2>
            </div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--muted)]">
              Selected clients · 2018 — Today
            </div>
          </div>
        </Reveal>
      </div>

      {/* Marquee row */}
      <div className="marquee-track py-4">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center gap-12 px-6 shrink-0">
            {PARTNERS.map((p, j) => (
              <div
                key={`${i}-${j}`}
                className="flex items-baseline gap-3 whitespace-nowrap"
              >
                <span className="font-display text-3xl md:text-5xl text-[var(--bone)] italic font-extralight">
                  {p.name}
                </span>
                <span className="text-xs uppercase tracking-[0.28em] text-[var(--muted)]">
                  {p.subtitle}
                </span>
                <span className="text-3xl md:text-5xl text-[var(--clay)] mx-4">✦</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}